import React from 'react';

const ImagePreview = ({ 
  imagePreview, 
  removeImage 
}) => {
  if (imagePreview.length === 0) return null;

  return (
    <div className="image-preview-container">
      <div className="image-preview-header">
      </div>
      <div className="image-preview-grid">
        {imagePreview.map((preview, index) => (
          <div key={index} className="image-preview-item">
            <img 
              src={preview.url} 
              alt={preview.name}
              className="preview-image"
            />
            <div className="preview-image-overlay">
              <button
                onClick={() => removeImage(index)}
                className="remove-image-btn"
                title="Remove image"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImagePreview;
